export default "__VITE_ASSET__KRf3TuLf__"